var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Projeto_ClienteActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Projeto_ClienteModule = class Projeto_ClienteModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Projeto_ClienteActions.POST_PROJETO_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.post("Projeto_Cliente/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Projeto_ClienteActions.PUT_PROJETO_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.put("Projeto_Cliente/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Projeto_ClienteActions.DELETE_PROJETO_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.delete("Projeto_Cliente/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Projeto_ClienteActions.DELETE_RANGE_PROJETO_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.delete("Projeto_Cliente/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Projeto_ClienteActions.FILTER_PROJETO_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.post("Projeto_Cliente/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Projeto_ClienteActions.GET_PROJETO_CLIENTE]() {
        return new Promise(resolve => {
            fornecService.get("Projeto_Cliente/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Projeto_ClienteActions.GETWITHDISABLED_PROJETO_CLIENTE]() {
        return new Promise(resolve => {
            fornecService.get("Projeto_Cliente/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Projeto_ClienteActions.GET_BY_ID_PROJETO_CLIENTE](data) {
        return new Promise(resolve => {
            fornecService.get("Projeto_Cliente/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Projeto_ClienteModule.prototype, _h, null);
Projeto_ClienteModule = __decorate([
    Module
], Projeto_ClienteModule);
export default Projeto_ClienteModule;
//# sourceMappingURL=Projeto_ClienteModule.js.map